"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.OrderStore = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _head2 = _interopRequireDefault(require("lodash/head"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _dateFns = require("date-fns");
var _loyaltyProductV = require("@tajawal/web-core-sdk-v2/lib/factories/loyalty-product-v2.factory");
var _ruleProductV = require("@tajawal/web-core-sdk-v2/lib/factories/rule-product-v2.factory");
var _skuProduct = require("@tajawal/web-core-sdk-v2/lib/factories/sku-product.factory");
var _cartProduct = require("@tajawal/web-core-sdk-v2/lib/utils/cart-product.utils");
var _cart = _interopRequireDefault(require("@tajawal/web-core-sdk-v2/lib/stores/cart.store"));
var _constants2 = require("../constants");
var _orderKnet = require("../factories/order-knet.factory");
var _orderContact = require("../factories/order-contact.factory");
var _order = require("../clients/order.client");
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
const {
  INITIAL,
  LOADING,
  SUCCESS,
  FAILED
} = _constants.API_STATE;
const {
  FURSAN,
  QITAF,
  WALLET,
  MOKAFAA
} = _constants2.LOYALTY_METHODS;
const {
  CHECKOUTCOM,
  PAYFORT,
  FORT,
  TAJAWAL_PAY,
  PAY_LATER
} = _constants2.PAYMENT_METHODS;

/**
 * order store
 */
let OrderStore = (_dec = _mobx.action.bound, (_class = /*#__PURE__*/function (_CartStore) {
  (0, _inherits2.default)(OrderStore, _CartStore);
  var _super = _createSuper(OrderStore);
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function OrderStore(initialState = {}, $env, makeProductFactory) {
    var _this;
    (0, _classCallCheck2.default)(this, OrderStore);
    _this = _super.call(this, initialState, $env, makeProductFactory);
    (0, _initializerDefineProperty2.default)(_this, "data", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "API_STATE", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    /**
     * get flight order by orderId and orderNumber
     * @param {object} prop
     * @param {string} prop.payload
     * @param {string} prop.payload.orderId
     * @param {string} prop.payload.orderNumber
     * @param {Function} [prop.errorHandler]
     */
    (0, _initializerDefineProperty2.default)(_this, "getOrder", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    _this.$env = $env;
    _this.makeProductFactory = makeProductFactory;
    _this.updateInitialState(initialState);
    return _this;
  }
  (0, _createClass2.default)(OrderStore, [{
    key: "isOrderLoading",
    get:
    /**
     * is loading
     * @return {boolean}
     */
    function () {
      return this.API_STATE === LOADING;
    }

    /**
     * is fetched
     * @return {boolean}
     */
  }, {
    key: "isOrderFetched",
    get: function () {
      return this.API_STATE === SUCCESS;
    }

    /**
     * is error
     * @return {boolean}
     */
  }, {
    key: "hasOrderError",
    get: function () {
      return this.API_STATE === FAILED;
    }

    /**
     * cart id
     * @return {string}
     */
  }, {
    key: "cartId",
    get: function () {
      return (0, _get2.default)(this.data, 'cartId');
    }

    /**
     * modified cart id (TODO - decide which to keep cartId or modifiedCartId based on product alignment)
     * @return {string}
     */
  }, {
    key: "modifiedCartId",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.cartId');
    }

    /**
     * modified cart id (TODO - decide which to keep cartId or modifiedCartId based on product alignment)
     * @return {string}
     */
  }, {
    key: "entityType",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.entityType');
    }

    /**
     * order number
     * @return {string}
     */
  }, {
    key: "orderNumber",
    get: function () {
      return (0, _get2.default)(this.data, 'orderNumber');
    }

    /**
     * payment method
     * @return {string}
     */
  }, {
    key: "paymentMethod",
    get: function () {
      return (0, _get2.default)(this.data, 'payment.paymentMethod');
    }
  }, {
    key: "card",
    get: function () {
      return (0, _get2.default)(this.data, 'payment.card');
    }

    /**
     * created at
     * @return {Date}
     */
  }, {
    key: "createdAt",
    get: function () {
      return (0, _dateFns.parse)((0, _get2.default)(this.data, 'createdAt'));
    }

    /**
     * has contact
     * @return {boolean}
     */
  }, {
    key: "hasContact",
    get: function () {
      return !(0, _isEmpty2.default)((0, _get2.default)(this.data, 'contact', {}));
    }

    /**
     * contact
     * @return {Object}
     */
  }, {
    key: "contact",
    get: function () {
      // return _get(this.data, 'contact');
      return (0, _orderContact.orderContactFactory)((0, _get2.default)(this.data, 'contact'));
    }

    /**
     * order status code
     * @return {number}
     */
  }, {
    key: "status",
    get: function () {
      return (0, _get2.default)(this.data, 'status');
    }

    /**
     * order displayStatus code
     * @return {number}
     */
  }, {
    key: "displayStatus",
    get: function () {
      return (0, _get2.default)(this.data, 'displayStatus');
    }

    /**
     * payment status
     * @return {number}
     */
  }, {
    key: "paymentStatus",
    get: function () {
      return (0, _get2.default)(this.data, 'paymentStatus');
    }

    /**
     * checks whether the order is still processing
     * @return {boolean}
     */
  }, {
    key: "isProcessing",
    get: function () {
      return this.status !== _constants2.BOOKING_STATUS.SUCCESS;
    }

    /**
     * order id
     * @return {string}
     */
  }, {
    key: "orderId",
    get: function () {
      return (0, _get2.default)(this.data, 'orderId', '');
    }

    /**
     * subtotal price
     * @return {string}
     */
  }, {
    key: "displayedBaseSubtotal",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.subtotal);
    }

    /**
     * order total
     * @return {string}
     */
  }, {
    key: "displayedBaseTotal",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.total);
    }

    /**
     * subtotal After Discount
     * @return {number}
     */
  }, {
    key: "subtotalAfterDiscount",
    get: function () {
      return (0, _get2.default)(this.data, 'displayTotals.subTotalAfterDiscount');
    }

    /**
     * subtotal After Discount
     * @return {number}
     */
  }, {
    key: "displayedBaseSubtotalAfterDiscount",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.subtotalAfterDiscount);
    }

    /**
     * displayed subtotal After Discount
     * @return {number}
     */
  }, {
    key: "displayedSubtotalAfterDiscount",
    get: function () {
      return this.$env.currency.convertAndFormatPrice(this.subtotalAfterDiscount);
    }

    /**
     * order total (formatted value without conversion)
     * @return {string}
     */
  }, {
    key: "orderTotal",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.total, 2);
    }

    /**
     * value added tax
     * @return {string}
     */
  }, {
    key: "displayedBaseVat",
    get: function () {
      return this.$env.currency.formatPriceWithDecimals(this.vat);
    }

    /**
     * order display currency
     * @return {string}
     */
  }, {
    key: "currency",
    get: function () {
      return (0, _get2.default)(this.data, 'displayCurrency', '');
    }

    /**
     * order currency
     * @return {string}
     */
  }, {
    key: "orderCurrency",
    get: function () {
      return (0, _get2.default)(this.data, 'currency', '');
    }

    /**
     * applied coupon code
     * @return {string}
     */
  }, {
    key: "coupon",
    get: function () {
      return (0, _get2.default)(this.data, 'coupon', '');
    }

    /**
     * order total USD
     * @return {string}
     */
  }, {
    key: "orderTotalUsd",
    get: function () {
      return (0, _get2.default)(this.data, 'orderTotalUsd');
    }

    /**
     * list of products
     * @return {number}
     */
  }, {
    key: "products",
    get: function () {
      return (0, _get2.default)(this.data, 'products', []);
    }

    /**
     * valid products
     * @return {Array<Object>}
     */
  }, {
    key: "validProducts",
    get: function () {
      return this.products.filter(_cartProduct.isValidProduct);
    }

    /**
     * product
     * @return {Object}
     */
  }, {
    key: "product",
    get: function () {
      console.log(this.$env.currency, 'this.$env.currency');
      if (this.validProducts.length > 0) {
        if (this.type === _constants2.PRODUCT_TYPES.FLIGHT) {
          return this.makeProductFactory({
            flightProduct: this.rawProduct,
            $currency: this.$env.currency
          });
        }
        return this.makeProductFactory(this.rawProduct);
      }
      return {};
    }

    /**
     * wallet product total (displayed value)
     * @return {string}
     */
  }, {
    key: "displayedWalletTotal",
    get: function () {
      return this.$env.currency.convertAndFormatPrice(this.walletTotal);
    }

    /**
     * track id
     * @return {string}
     */
  }, {
    key: "trackId",
    get: function () {
      return (0, _get2.default)(this.data, 'trackId', '');
    }

    /**
     * allowed payment methods
     * @return {string}
     */
  }, {
    key: "allowedPaymentMethods",
    get: function () {
      return (0, _get2.default)(this.data, 'allowedPaymentMethods', []).map(m => m.provider);
    }

    /**
     * returns merchant id for apple pay header
     * @returns {String}
     */
  }, {
    key: "appleMIdHeader",
    get: function () {
      var _this$data, _this$data$allowedPay, _this$data$allowedPay2;
      return (_this$data = this.data) === null || _this$data === void 0 ? void 0 : (_this$data$allowedPay = _this$data.allowedPaymentMethods) === null || _this$data$allowedPay === void 0 ? void 0 : (_this$data$allowedPay2 = _this$data$allowedPay.find(x => x.applemid)) === null || _this$data$allowedPay2 === void 0 ? void 0 : _this$data$allowedPay2.applemid;
    }

    /**
     * allowed card payment methods
     * @return {string}
     */
  }, {
    key: "paymentCardOption",
    get: function () {
      const cardMethods = [CHECKOUTCOM, PAYFORT, TAJAWAL_PAY, FORT];
      const allowedCardMethods = (0, _intersection2.default)(this.allowedPaymentMethods, cardMethods);
      return (0, _head2.default)(allowedCardMethods);
    }

    /**
     * checks if the order is already paid
     * @return {boolean}
     */
  }, {
    key: "isPaidOrder",
    get: function () {
      return this.paidWithBank || this.paidWithCreditCard || this.paidWithKnet;
    }

    /**
     * checks if payment done through KNET
     * @return {boolean}
     */
  }, {
    key: "paidWithKnet",
    get: function () {
      return !!(0, _get2.default)(this.data, 'additionalData.knet.referenceId') && !!(0, _get2.default)(this.data, 'additionalData.knet.paymentId') && !!(0, _get2.default)(this.data, 'additionalData.knet.merchantId');
    }

    /**
     * checks if payment done through Card
     * @return {boolean}
     */
  }, {
    key: "paidWithCreditCard",
    get: function () {
      return [CHECKOUTCOM, PAYFORT, FORT].includes((0, _get2.default)(this.data, 'payment.paymentMethod'));
    }

    /**
     * checks if payment done through Bank
     * @return {boolean}
     */
  }, {
    key: "paidWithBank",
    get: function () {
      return (0, _get2.default)(this.data, 'payment.paymentMethod') === PAY_LATER && !!(0, _get2.default)(this.data, 'payment.referenceId');
    }

    /**
     * knet payment object
     * @return {string}
     */
  }, {
    key: "knet",
    get: function () {
      return (0, _orderKnet.orderKnetFactory)((0, _get2.default)(this.data, 'additionalData.knet'));
    }

    /**
     * customer id
     * @return {string}
     */
  }, {
    key: "customerId",
    get: function () {
      return (0, _get2.default)(this.data, 'customerId');
    }

    /**
     * has customer id
     * @return {boolean}
     */
  }, {
    key: "hasCustomerId",
    get: function () {
      return !!this.customerId;
    }

    /**
     * has reward
     * @return {boolean}
     */
  }, {
    key: "hasReward",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.hasReward', false);
    }

    /**
     * reward method
     * @return {string}
     */
  }, {
    key: "rewardMethod",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.method', '');
    }

    /**
     * reward value
     * @return {number}
     */
  }, {
    key: "rewardValue",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.rewardValue', 0);
    }

    /**
     * reward points
     * @return {number}
     */
  }, {
    key: "rewardPoints",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.rewardPoints', this.rewardValue);
    }

    /**
     * reward points
     * @return {string}
     */
  }, {
    key: "rewardExpiryDate",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.rewardExpiryDate', '');
    }

    /**
     * reward identifier
     * @return {string}
     */
  }, {
    key: "rewardIdentifier",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.reward.identifier', '');
    }

    /**
     * has fursan reward
     * @return {boolean}
     */
  }, {
    key: "hasFursanReward",
    get: function () {
      return this.rewardMethod === FURSAN;
    }

    /**
     * has mokafaa reward
     * @return {boolean}
     */
  }, {
    key: "hasMokafaaReward",
    get: function () {
      return this.rewardMethod === MOKAFAA;
    }

    /**
     * has qitaf reward
     * @return {boolean}
     */
  }, {
    key: "hasQitafReward",
    get: function () {
      return this.rewardMethod === QITAF;
    }

    /**
     * has wallet reward
     * @return {boolean}
     */
  }, {
    key: "hasWalletReward",
    get: function () {
      return this.rewardMethod === WALLET;
    }

    /**
     * has redeem
     * @return {boolean}
     */
  }, {
    key: "hasRedeem",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.hasRedeem', false);
    }

    /**
     * redeem method
     * @return {boolean}
     */
  }, {
    key: "redeemMethod",
    get: function () {
      return (0, _get2.default)(this.data, 'additionalData.loyalty.redeem.method', '');
    }

    /**
     * has qitaf redeem
     * @return {boolean}
     */
  }, {
    key: "hasQitafRedeem",
    get: function () {
      return this.redeemMethod === QITAF;
    }

    /**
     * has mokafaa redeem
     * @return {boolean}
     */
  }, {
    key: "hasMokafaaRedeem",
    get: function () {
      return this.redeemMethod === MOKAFAA;
    }

    /**
     * has wallet redeem
     * @return {boolean}
     */
  }, {
    key: "hasWalletRedeem",
    get: function () {
      return this.redeemMethod === WALLET;
    }

    /**
     * last 4 digits in card number
     * @return {string}
     */
  }, {
    key: "last4DigitsInCardNumber",
    get: function () {
      return (0, _get2.default)(this.data, 'payment.card.last4', '');
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @param {Object} data
     */
    function onSuccess(data, successHandler) {
      this.data = data;
      this.API_STATE = SUCCESS;
      successHandler && successHandler();
    }

    /**
     * handle error
     * @param {Object} error
     * @param {Function} errorHandler
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      errorHandler(error);
      this.API_STATE = FAILED;
    }
  }]);
  return OrderStore;
}(_cart.default), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return INITIAL;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isOrderLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isOrderFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasOrderError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasOrderError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "cartId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "modifiedCartId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "modifiedCartId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "entityType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "entityType"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderNumber", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderNumber"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paymentMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentMethod"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "card", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "card"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "createdAt", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "createdAt"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasContact", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasContact"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "contact", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "contact"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "status", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "status"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayStatus"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paymentStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentStatus"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isProcessing", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isProcessing"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedBaseSubtotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedBaseSubtotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedBaseTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedBaseTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "subtotalAfterDiscount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "subtotalAfterDiscount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedBaseSubtotalAfterDiscount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedBaseSubtotalAfterDiscount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedSubtotalAfterDiscount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedSubtotalAfterDiscount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedBaseVat", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedBaseVat"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "currency", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currency"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderCurrency", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderCurrency"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "coupon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "coupon"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderTotalUsd", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderTotalUsd"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "products", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "products"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "validProducts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "validProducts"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "product", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "product"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayedWalletTotal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayedWalletTotal"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "trackId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "trackId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "allowedPaymentMethods", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "allowedPaymentMethods"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "appleMIdHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "appleMIdHeader"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paymentCardOption", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentCardOption"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPaidOrder", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPaidOrder"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paidWithKnet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paidWithKnet"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paidWithCreditCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paidWithCreditCard"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paidWithBank", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paidWithBank"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "knet", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "knet"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "customerId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "customerId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasCustomerId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCustomerId"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardMethod"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardValue", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardValue"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardPoints", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardPoints"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardExpiryDate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardExpiryDate"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "rewardIdentifier", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardIdentifier"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasFursanReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasFursanReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasMokafaaReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMokafaaReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasQitafReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasQitafReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasWalletReward", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasWalletReward"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasRedeem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasRedeem"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "redeemMethod", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "redeemMethod"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasQitafRedeem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasQitafRedeem"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasMokafaaRedeem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMokafaaRedeem"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasWalletRedeem", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasWalletRedeem"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "last4DigitsInCardNumber", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "last4DigitsInCardNumber"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getOrder", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (0, _mobx.flow)(function* getOrder({
      payload,
      errorHandler = () => null,
      successHandler = () => null
    }) {
      this.API_STATE = LOADING;
      try {
        const response = yield _order.OrderClient.getOrder(payload);
        this.onSuccess(response, successHandler);
      } catch (e) {
        console.log({
          e
        });
        this.onError(e, errorHandler);
      }
    });
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype)), _class));
exports.OrderStore = OrderStore;